<template>
  <b-container fluid>
    <b-row
      class="justify-content-between"
      cols="auto"
      md="auto"
      lg="auto"
    >
      <b-col>
        <b-input-group style="margin-bottom: 10px;">
          <b-input-group-append>
            <div class="o-search">
              <i class="fa fa-search" />
            </div>
          </b-input-group-append>
          <b-form-input
            v-model="filter"
            placeholder="SEARCH"
          />
          <b-input-group-append>
            <b-button
              :disabled="!filter"
              @click="filter = ''"
            >
              <i class="fa fa-times" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-table
          id="identityResourcess"
          primary-key="id"
          head-variant="light"
          fixed
          small
          responsive
          :busy="isLoading"
          :items="identityResources"
          :fields="fields"
          :per-page="selectedPageSize"
          :total-rows="rows"
          :current-page="currentPage"
          :filter="filter"
          style="background-color: transparent"
          @filtered="onFiltered"
        >
          <div
            slot="table-busy"
            class="text-center my-2"
          >
            <b-spinner class="align-middle" />
            <span class="o-strong">&nbsp;Loading&hellip;</span>
          </div>
          
          <template
            slot="enabled"
            slot-scope="row"
          >
            <div v-if="row.item.enabled === true">
              <i
                v-b-tooltip.hover.left
                class="fa fa-circle o-enabled"
                title="Enabled"
              />
            </div>
            <div v-else>
              <i
                v-b-tooltip.hover.left
                class="fa fa-circle o-disabled"
                title="Disabled"
              />
            </div>
          </template>

          <template
            slot="edit"
            slot-scope="row"
          >
            <b-button
              v-b-tooltip.hover.left
              variant="link"
              class="px-0 py-1"
              title="Edit Resource"
              @click="editIdentityResource(row.item)"
            >
              <i class="fa fa-pencil" />
            </b-button>
          </template>
          
          <template
            slot="delete"
            slot-scope="row"
          >
            <b-button
              v-b-tooltip.hover.left
              variant="link"
              class="px-0 py-1"
              title="Delete Resource"
              @click="deleteIdentityResource(row.item)"
            >
              <i class="fa fa-trash" />
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row v-show="isLoading === false">
      <b-col
        cols="auto"
        class="pr-2"
      >
        <b-pagination
          v-model="currentPage"
          size="sm"
          :total-rows="rows"
          :per-page="selectedPageSize"
          aria-controls="apiResources"
        />
      </b-col>
      <b-col
        cols="auto"
        class="mr-sm-auto mr-lg-0 o-page-count"
      >
        OF&nbsp;
        <span class="o-strong">{{ pageCount }}</span>
      </b-col>
      <b-col
        sm="12"
        lg="auto"
        class="o-page-size"
      >
        <b-form-group>
          <b-select
            id="pageSize"
            :value="selectedPageSize"
            class="ml-0 ml-lg-2"
            style="width: 65px;"
            :options="options"
            size="sm"
            @input="updatePageSize"
          />
          <label
            class="mr-3"
            for="pageSize"
          >PER PAGE</label>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-alert
          v-model="showAlert"
          variant="danger"
          dismissible
        >
          {{ alertMessage }}
        </b-alert>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "IdentityResourceList",
  data() {
    return {
      filter: "",
      totalRows: 1,
      fields: [
        { key: "name", thClass: "text-truncate", tdClass: "text-truncate" },
        {
          key: "displayName",
          thClass: "text-truncate",
          tdClass: "text-truncate"
        },
        {
          key: "enabled",
          label: "",
          thClass: "o-th",
          tdClass: "o-td-center"
        },
        {
          key: "edit",
          label: "",
          thClass: "o-th",
          tdClass: "o-td-center"
        },
        {
          key: "delete",
          label: "",
          thClass: "o-th",
          tdClass: "o-td-center"
        }
      ],
      identityResources: [],
      options: [
        { value: 5, text: "5" },
        { value: 10, text: "10" },
        { value: 15, text: "15" },
        { value: 20, text: "20" },
        { value: 30, text: "30" },
        { value: 50, text: "50" }
      ]
    };
  },
  computed: {
    ...mapGetters({
      isLoading: "isLoading",
      selectedPageSize: "identityResourceListPageSize"
    }),
    showAlert: {
      get() {
        return this.$store.getters.showAlert;
      },
      set(value) {
        this.$store.dispatch("showAlert", value);
      }
    },
    alertMessage: {
      get() {
        return this.$store.getters.alertMessage;
      },
      set(value) {
        this.$store.dispatch("alertMessage", value);
      }
    },
    currentPage: {
      get() {
        return this.$store.getters.identityResourceListCurrentPage;
      },
      set(value) {
        this.$store.commit("SET_IDENTITYRESOURCELIST_CURRENTPAGE", value);
      }
    },
    rows() {
      return this.totalRows;
    },
    pageCount() {
      let totalPages = Math.floor(
        Number(this.rows) / Number(this.selectedPageSize)
      );
      if (Number(this.rows) % Number(this.selectedPageSize) != 0) totalPages++;
      return totalPages;
    }
  },
  mounted() {
    this.loadIdentityResources();
  },
  methods: {
    ...mapActions({
      updatePageSize: "identityResourceListPageSize"
    }),
    loadIdentityResources() {
      this.$axios
        .get("api/identityResources")
        .then(response => {
          this.identityResources = response.data;
          this.totalRows = this.identityResources.length;
        })
        .catch(error => {
          this.alertMessage = error;
        });
    },
    addIdentityResource() {
      this.$router.push({ path: `identityResources/new` });
    },
    editIdentityResource(item) {
      this.$router.push({ path: `identityResources/${item.id}/edit` });
    },
    deleteIdentityResource(item) {
      this.dialogResult = "";
      let msg = `Continue to delete ${item.name}?`;
      this.$bvModal
        .msgBoxConfirm(msg, {
          title: "Please Confirm",
          size: "lg",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value === true) {
            this.$axios
              .delete(`/api/identityResources/${item.id}/delete`)
              .then(() => {
                this.identityResources = this.identityResources.filter(
                  t => t.id != item.id
                );
                this.totalRows = this.identityResources.length;
              })
              .catch(error => {
                this.alertMessage = error;
              });
          }
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows =
        this.filter === ""
          ? this.identityResources.length
          : filteredItems.length;
    }
  }
};
</script>

